import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { authLink } from '../common/auth/api';

export const client = new ApolloClient({
    link: authLink.concat(
        createHttpLink({
            uri: '/resource/v1/'
        })
    ),
    cache: new InMemoryCache({
        addTypename: false
    })
});
